import { AccountDocument, AdjustMonthlyPaymentCapTypes } from 'types';

import { api } from './api';

export const monthlyPaymentCapsApi = api.injectEndpoints({
  endpoints: (build) => ({
    adjustMonthlyPaymentCaps: build.mutation<
      AccountDocument,
      { id: string; data: { adjustmentOption: AdjustMonthlyPaymentCapTypes } }
    >({
      query: ({ id, data }) => ({
        url: `accounts/${id}/monthly-payment-caps/adjust`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: (_result, _error, { id }) => [{ type: 'Accounts', id }],
    }),
  }),
});

export const { useAdjustMonthlyPaymentCapsMutation } = monthlyPaymentCapsApi;
